import { IsNotEmpty, IsNumber, IsString } from 'class-validator';

export class OrderCacheCreateDto {
  @IsNotEmpty()
  @IsString()
  surfboardOrderId: string;

  @IsNotEmpty()
  @IsString()
  surfboardPaymentId: string;

  @IsNotEmpty()
  @IsNumber()
  surfboardPaymentAmount: number;

  @IsNotEmpty()
  cart: any;
}